
// priority of configuration
// 1. baked in through webpack build (process.env.*)
// 2. window configured via server
// 3. fallback value, depends on field, other window location, or localhost

const windowUrl = window.location.protocol + "//" + window.location.host

// from api server
const injected = window.APPLICATION_CONFIG || {};

/** magic value WINDOW_URL gets transformed into the windows current url */
function transformWindowUrl(value) {
  return value === "WINDOW_URL" ? windowUrl : value
}
const assetUrl = transformWindowUrl(process.env.ASSET_URL || injected.assetUrl) || windowUrl;
const apiUrl = transformWindowUrl(process.env.API_URL || injected.apiUrl) || (assetUrl === windowUrl ? "http://localhost:9000" : windowUrl);

// const themeApiURL = `http://localhost:8081`;
const themeApiURL = process.env.THEME_API_URL || injected.themeApiUrl || (`https://themes.chatmeter.com`);

const wsprotocol = apiUrl.match(/^https:/) ? 'wss:' : 'ws:';
const apiSocketUrl = apiUrl.replace(/^https?:/, wsprotocol);
  
// TODO - callers reference the config instead of window.assetUrl
window.assetUrl = assetUrl

export default {
  assetUrl, apiUrl, apiSocketUrl, themeApiURL
}